import { EyesPosition } from 'src/models/Session.model';

import AnalysisFailedStatusCard from './AnalysisFailedStatusCard';
import BadQualityStatusCard from './BadQualityStatusCard';
import GradableStatusCard from './GradableStatusCard';
import InProgressStatusCard from './InProgressStatusCard';

type StatusCardControllerProps = {
  hasServerError: boolean;
  gradableEyesPosition: EyesPosition | undefined;
  isAnalyzing: boolean;
};

export default function StatusCardController({
  hasServerError,
  gradableEyesPosition,
  isAnalyzing,
}: StatusCardControllerProps) {
  if (hasServerError) {
    return <AnalysisFailedStatusCard />;
  }
  if (isAnalyzing) {
    return <InProgressStatusCard />;
  }
  // Post analysis cards
  if (gradableEyesPosition === undefined) {
    return <BadQualityStatusCard eye={EyesPosition.BOTH} />;
  }
  if (gradableEyesPosition === EyesPosition.LEFT) {
    return <BadQualityStatusCard eye={EyesPosition.RIGHT} />;
  }
  if (gradableEyesPosition === EyesPosition.RIGHT) {
    return <BadQualityStatusCard eye={EyesPosition.LEFT} />;
  }
  if (gradableEyesPosition === EyesPosition.BOTH) {
    return <GradableStatusCard />;
  }
}
